import dates from 'utils/dates';
import Immutable from 'immutable';
import { serialize, isHotelOnly, updateWindowLocation } from 'utils/utils';
import { getFieldKeysByPassenger, getFieldKeysByPassengerHO } from 'utils/book';

import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  BOOK_REQUEST: 'BOOK_REQUEST',
  BOOK_SUCCESS: 'BOOK_SUCCESS',
  BOOK_FAILURE: 'BOOK_FAILURE',
  BOOK_SAVE_USER_INFO_REQUEST: 'BOOK_SAVE_USER_INFO_REQUEST',
  BOOK_SAVE_USER_INFO_SUCCESS: 'BOOK_SAVE_USER_INFO_SUCCESS',
  BOOK_SAVE_USER_INFO_FAILURE: 'BOOK_SAVE_USER_INFO_FAILURE',
  REBOOK_VALIDATION_REQUEST: 'REBOOK_VALIDATION_REQUEST',
  REBOOK_VALIDATION_SUCCESS: 'REBOOK_VALIDATION_SUCCESS',
  REBOOK_VALIDATION_FAILURE: 'REBOOK_VALIDATION_FAILURE',
  BOOK_BRAINTREE_TOKEN_REQUEST: 'BOOK_BRAINTREE_TOKEN_REQUEST',
  BOOK_BRAINTREE_TOKEN_SUCCESS: 'BOOK_BRAINTREE_TOKEN_SUCCESS',
  BOOK_BRAINTREE_TOKEN_FAILURE: 'BOOK_BRAINTREE_TOKEN_FAILURE',
  BOOK_EXTRAS_REQUEST: 'BOOK_EXTRAS_REQUEST',
  BOOK_EXTRAS_SUCCESS: 'BOOK_EXTRAS_SUCCESS',
  BOOK_EXTRAS_FAILURE: 'BOOK_EXTRAS_FAILURE',
  BOOK_SET_ROOM_OPTION: 'BOOK_SET_ROOM_OPTION',
  BOOK_SET_TRANSFER_OPTION: 'BOOK_SET_TRANSFER_OPTION',
  BOOK_SET_INSURANCE_OPTION: 'BOOK_SET_INSURANCE_OPTION',
  BOOK_SET_PARKING_OPTION: 'BOOK_SET_PARKING_OPTION',
  BOOK_SET_HAS_HEALTH_ISSUES: 'BOOK_SET_HAS_HEALTH_ISSUES',
  BOOK_SET_EXTRAS_BAGGAGE: 'BOOK_SET_EXTRAS_BAGGAGE',
  BOOK_ADD_EXTRAS_FLIGHT_MEAL: 'BOOK_ADD_EXTRAS_FLIGHT_MEAL',
  BOOK_REMOVE_EXTRAS_FLIGHT_MEAL: 'BOOK_REMOVE_EXTRAS_FLIGHT_MEAL',
  BOOK_SET_PASSENGER_FIELD: 'BOOK_SET_PASSENGER_FIELD',
  BOOK_SET_PASSENGER_FIELD_SET: 'BOOK_SET_PASSENGER_FIELD_SET',
  BOOK_VALIDATE_PASSENGER_FIELD: 'BOOK_VALIDATE_PASSENGER_FIELD',
  BOOK_VALIDATE_PASSENGER_FIELD_SET: 'BOOK_VALIDATE_PASSENGER_FIELD_SET',
  BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG: 'BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG',
  BOOK_SET_PAYMENT_PLAN: 'BOOK_SET_PAYMENT_PLAN',
  BOOK_SET_PAYMENT_DETAILS: 'BOOK_SET_PAYMENT_DETAILS',
  BOOK_SET_PAYMENT_METHOD: 'BOOK_SET_PAYMENT_METHOD',
  BOOK_VALIDATE_PAYMENT_DETAILS: 'BOOK_VALIDATE_PAYMENT_DETAILS',
  BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET: 'BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET',
  BOOK_POSTCODE_LOOKUP_REQUEST: 'BOOK_POSTCODE_LOOKUP_REQUEST',
  BOOK_POSTCODE_LOOKUP_SUCCESS: 'BOOK_POSTCODE_LOOKUP_SUCCESS',
  BOOK_POSTCODE_LOOKUP_FAILURE: 'BOOK_POSTCODE_LOOKUP_FAILURE',
  BOOK_SET_AGENT_WEB_PRICE_DELTA: 'BOOK_SET_AGENT_WEB_PRICE_DELTA',
  BOOK_CHANGE_AGENT_HO_BOOKING_TYPE: 'BOOK_CHANGE_AGENT_HO_BOOKING_TYPE',
  BOOK_SET_ADDRESS_FIELDS: 'BOOK_SET_ADDRESS_FIELDS',
  BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS: 'BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS',
  BOOK_SET_PROMOCODE: 'BOOK_SET_PROMOCODE',
  BOOK_SET_WAITING_FOR_SERVER: 'BOOK_SET_WAITING_FOR_SERVER',
  BOOK_UPDATE_PAYMENT_PLANS: 'BOOK_UPDATE_PAYMENT_PLANS',
  ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION: 'ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION',
  BOOK_SEND_DEAL: 'BOOK_SEND_DEAL',
  BOOK_SEND_DEAL_RESULT: 'BOOK_SEND_DEAL_RESULT',
  BOOK_SELECT_AIRLINE_SEAT: 'BOOK_SELECT_AIRLINE_SEAT',
  BOOK_CLEAR_SELECTED_AIRLINE_SEATS: 'BOOK_CLEAR_SELECTED_AIRLINE_SEATS',
  BOOK_SELECT_HIRE_CAR: 'BOOK_SELECT_HIRE_CAR',
};

export function loadBook(params) {
  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_REQUEST,
        TYPES.BOOK_SUCCESS,
        TYPES.BOOK_FAILURE,
      ],
      schema: Schemas.BOOK,
      endpoint: `/book/api/?${serialize(params)}`,
    },
  };
}

export function loadBookExtras(params) {
  const blankFormData = { booking_info: {} };

  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_EXTRAS_REQUEST,
        TYPES.BOOK_EXTRAS_SUCCESS,
        TYPES.BOOK_EXTRAS_FAILURE,
      ],
      schema: Schemas.BOOK,
      endpoint: `/book/api/?${serialize(params)}`,
      requestOptions: {
        method: 'PUT',
        formData: blankFormData,
      },
    },
  };
}

export function postBook(params, formData = {}) {
  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_REQUEST,
        TYPES.BOOK_SUCCESS,
        TYPES.BOOK_FAILURE,
      ],
      schema: Schemas.BOOK,
      endpoint: `/book/api/?${serialize(params)}`,
      requestOptions: {
        method: 'POST',
        formData,
      },
    },
  };
}

export function postUserInfo(params, formData = {}) {
  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_SAVE_USER_INFO_REQUEST,
        TYPES.BOOK_SAVE_USER_INFO_SUCCESS,
        TYPES.BOOK_SAVE_USER_INFO_FAILURE,
      ],
      endpoint: `/book/save-user-info?${serialize(params)}`,
      requestOptions: {
        method: 'POST',
        formData,
      },
    },
  };
}

export function setRoomOption(partyIndex, id) {
  return {
    type: TYPES.BOOK_SET_ROOM_OPTION,
    partyIndex,
    id,
  };
}

export function setTransferOption(id) {
  return {
    type: TYPES.BOOK_SET_TRANSFER_OPTION,
    id,
  };
}

export function setParkingOption(id) {
  return {
    type: TYPES.BOOK_SET_PARKING_OPTION,
    id,
  };
}

export function setInsuranceOption(id) {
  return {
    type: TYPES.BOOK_SET_INSURANCE_OPTION,
    id,
  };
}

export function setHasHealthIssues(hasHealthIssues) {
  return {
    type: TYPES.BOOK_SET_HAS_HEALTH_ISSUES,
    hasHealthIssues,
  };
}

export function setExtrasBaggage(list) {
  return {
    type: TYPES.BOOK_SET_EXTRAS_BAGGAGE,
    list,
  };
}

export function addExtrasFlightMeal(id) {
  return {
    type: TYPES.BOOK_ADD_EXTRAS_FLIGHT_MEAL,
    id,
  };
}

export function removeExtrasFlightMeal(id) {
  return {
    type: TYPES.BOOK_REMOVE_EXTRAS_FLIGHT_MEAL,
    id,
  };
}

function updateFormValidFlag(dispatch, getState) {
  const { featureFlags, bookState, router } = getState();

  if (featureFlags.get('OfferSummaryCTA2') || featureFlags.get('OfferSummaryCTA3')) {
    const isFormHotelOnly = isHotelOnly(router.location.pathname);

    dispatch(({
      type: TYPES.BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG,
      fieldSet: isFormHotelOnly ? 'passengerDetailsHO' : 'passengerDetails',
      passengerIds: bookState.getIn(['booking_info', 'passengers']),
      fieldKeysByPassenger: isFormHotelOnly ? getFieldKeysByPassengerHO(bookState) : getFieldKeysByPassenger(bookState),
      passengers: bookState.getIn(['entities', 'passengers']),
      leadPassengerId: bookState.getIn(['booking_info', 'leadPassengerId'], 0),
      inboundFlightDeptDate: bookState.getIn(['data', 'flight', 'inbound', 'deptDate']),
    }));
  }
}

export function setPassengerField({ passengerId, fieldKey, value }) {
  return (dispatch, getState) => {
    const result = dispatch({
      type: TYPES.BOOK_SET_PASSENGER_FIELD,
      passengerId,
      fieldKey,
      value,
    });

    updateFormValidFlag(dispatch, getState);

    return result;
  };
}

export function setPassengerFieldSet({ passengerId, fieldKey, value, fieldSet, passengerIds, fieldKeysByPassenger, passengers, leadPassengerId, inboundFlightDeptDate }) {
  return (dispatch, getState) => {
    const result = dispatch({
      type: TYPES.BOOK_SET_PASSENGER_FIELD_SET,
      passengerId,
      fieldKey,
      value,
      fieldSet,
      passengerIds,
      fieldKeysByPassenger,
      passengers,
      leadPassengerId,
      inboundFlightDeptDate,
    });

    updateFormValidFlag(dispatch, getState);

    return result;
  };
}

function sendUserInfoIfValid(dispatch, getState) {
  const shouldSendUserDetails = !getState().bookState.get('sentUserInfo');

  if (shouldSendUserDetails) {
    const { router, bookValidation, bookState } = getState();
    const leadPassengerId = bookState.getIn(['booking_info', 'leadPassengerId'], 0);
    const firstPassengerValidity = bookValidation.getIn(['passengers', `${leadPassengerId}`], Immutable.Map());
    const firstPassenger = bookState.getIn(['entities', 'passengers', '0'], Immutable.Map());

    const allRequiredFieldsValid = ['firstName', 'lastName', 'email', 'telephone']
      .every(key => firstPassengerValidity.getIn([key, 'isValid']));

    if (allRequiredFieldsValid) {
      const shortref = router.location.query.shortref;

      dispatch(postUserInfo({ shortref, 'session-id': shortref }, {
        'adult-0-first_name': firstPassenger.get('firstName'),
        'adult-0-last_name': firstPassenger.get('lastName'),
        email: firstPassenger.get('email'),
        contact: firstPassenger.get('telephone'),
      }));
    }
  }
}

export function validatePassengerField({ passengerId, fieldKey, value }) {
  return (dispatch, getState) => {
    dispatch({
      type: TYPES.BOOK_VALIDATE_PASSENGER_FIELD,
      passengerId,
      fieldKey,
      value,
    });

    sendUserInfoIfValid(dispatch, getState);
  };
}

export function validatePassengerFieldSet({ fieldSet, passengerIds, fieldKeysByPassenger, passengers, leadPassengerId, inboundFlightDeptDate }) {
  return (dispatch, getState) => {
    dispatch({
      type: TYPES.BOOK_VALIDATE_PASSENGER_FIELD_SET,
      fieldSet,
      passengerIds,
      fieldKeysByPassenger,
      passengers,
      leadPassengerId,
      inboundFlightDeptDate,
    });

    sendUserInfoIfValid(dispatch, getState);

    return Promise.resolve(getState());
  };
}

export function setPaymentPlan(id) {
  return {
    type: TYPES.BOOK_SET_PAYMENT_PLAN,
    id,
  };
}

export function setPaymentDetails({ fieldKey, value, securityCodeLength, cardNumberLengthRange }) {
  return {
    type: TYPES.BOOK_SET_PAYMENT_DETAILS,
    fieldKey,
    value,
    securityCodeLength,
    cardNumberLengthRange,
  };
}

export function setPaymentMethod(value) {
  return {
    type: TYPES.BOOK_SET_PAYMENT_METHOD,
    value,
  };
}

export function validatePaymentDetails({ fieldKey, value, securityCodeLength, cardNumberLengthRange }) {
  return {
    type: TYPES.BOOK_VALIDATE_PAYMENT_DETAILS,
    fieldKey,
    value,
    securityCodeLength,
    cardNumberLengthRange,
  };
}

export function validatePaymentDetailsFieldSet({ fieldSet, fieldKeys, fieldValues, securityCodeLength, cardNumberLengthRange }) {
  return (dispatch, getState) => {
    dispatch({
      type: TYPES.BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET,
      nowDate: dates.utcDate(),
      fieldSet,
      fieldKeys,
      fieldValues,
      securityCodeLength,
      cardNumberLengthRange,
    });

    return Promise.resolve(getState());
  };
}

export function setAgentWebPriceDelta(agentWebPriceDelta) {
  return {
    type: TYPES.BOOK_SET_AGENT_WEB_PRICE_DELTA,
    agentWebPriceDelta,
  };
}

export function changeAgentHOBookingType(value) {
  return {
    type: TYPES.BOOK_CHANGE_AGENT_HO_BOOKING_TYPE,
    value,
  };
}

export function loadPostcodeLookup(params) {
  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_POSTCODE_LOOKUP_REQUEST,
        TYPES.BOOK_POSTCODE_LOOKUP_SUCCESS,
        TYPES.BOOK_POSTCODE_LOOKUP_FAILURE,
      ],
      endpoint: `/ajax/lookup/?${serialize(params)}`,
    },
  };
}

export function setAddressFields({ passengerId, address1, address2, city, county }) {
  return {
    type: TYPES.BOOK_SET_ADDRESS_FIELDS,
    passengerId,
    address1,
    address2,
    city,
    county,
  };
}

export function clearPostcodeOnlyAddressFields({ passengerId }) {
  return {
    type: TYPES.BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS,
    passengerId,
  };
}

export function setPromoCode(value) {
  return {
    type: TYPES.BOOK_SET_PROMOCODE,
    value,
  };
}

export function postRebookValidation(params, formData = {}) {
  return {
    [CALL_API]: {
      types: [
        TYPES.REBOOK_VALIDATION_REQUEST,
        TYPES.REBOOK_VALIDATION_SUCCESS,
        TYPES.REBOOK_VALIDATION_FAILURE,
      ],
      endpoint: `/book/rebooking-validation.json?${serialize(params)}`,
      requestOptions: {
        method: 'POST',
        formData,
      },
    },
  };
}

export function setWaitingForServer(isWaiting) {
  return {
    type: TYPES.BOOK_SET_WAITING_FOR_SERVER,
    isWaiting,
  };
}

export function postGenerateBraintreeToken() {
  return {
    [CALL_API]: {
      types: [
        TYPES.BOOK_BRAINTREE_TOKEN_REQUEST,
        TYPES.BOOK_BRAINTREE_TOKEN_SUCCESS,
        TYPES.BOOK_BRAINTREE_TOKEN_FAILURE,
      ],
      endpoint: '/book/api/braintree/generate-token',
      requestOptions: {
        method: 'POST',
        formData: {},
      },
    },
  };
}

export const goToToiletPage = (shortRef, channel = undefined) => () => {
  const channelParameter = channel ? `&channel=${channel}` : '';
  const pathname = `/book/call-center.html?shortref=${shortRef}${channelParameter}`;

  updateWindowLocation(pathname);
};

export const updatePaymentPlans = bookResponse => ({
  type: TYPES.BOOK_UPDATE_PAYMENT_PLANS,
  bookResponse,
});

export function acknowledgeAssistedBookingNotification() {
  return {
    type: TYPES.ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION,
  };
}

export const sendDeal = () => ({
  type: TYPES.BOOK_SEND_DEAL,
});

export const setSendDealResult = result => ({
  type: TYPES.BOOK_SEND_DEAL_RESULT,
  result,
});

export const selectAirlineSeat = (direction, passengerId, row, seat) => ({
  type: TYPES.BOOK_SELECT_AIRLINE_SEAT,
  direction,
  passengerId,
  row,
  seat,
});

export const clearSelectedAirlineSeats = direction => ({
  type: TYPES.BOOK_CLEAR_SELECTED_AIRLINE_SEATS,
  direction,
});

export const selectHireCar = (hireCarId, extraIds = []) => ({
  type: TYPES.BOOK_SELECT_HIRE_CAR,
  hireCarId,
  extraIds,
  closeModal: true,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/bookActions.js
 **/